const getAPIUrl = async () => {
  //si el environtment es development devuelvo hardcodeada la url de la API
  if (process.env.NODE_ENV == "development")
    return `${process.env.VUE_APP_URL}`;
  else return `https://rpfacil-api-test.azurewebsites.net/`;
};

export default getAPIUrl;
